import React, { useState, useEffect } from 'react';
import { getComandas } from '../helpers/rutaComandas';
import { postViaje, putViaje } from '../helpers/rutaViajes';
import { getEstaciones } from '../helpers/rutaEstaciones'; // creá esta función si no la tenés
import { getCajas } from '../helpers/rutaCajas';
import styled from 'styled-components';

const formatoDinero = (valor) => {
  const n = Number(valor || 0);

  return n.toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const TextoAzul = styled.span`
  color: #2563eb !important;
  font-weight: bold;
  transition: color 0.2s ease;

  &:hover {
    color: #1e40af;
  }
`;

const BotonForm = styled.button`
  background-color: #044a78ff;
  color: white;
  padding: 0.5rem 1rem;
  width: 120px;
  border: none;
  font-size: 1.2rem;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #06345fff;
  }
`;

export default function Viaje() {
  const [viaje, setViaje] = useState({
    nroViaje: '',
    chofer: '',
    camion: '',
    valorKM: 130,
    kmInicioTablero: '',
    kmFinTablero: '',
    tramos: [],
    combustible: [],
    viaticos: [],
    adelantos: [],
    gastos: []
  });

  const [comandas, setComandas] = useState([]);

  useEffect(() => {
    getComandas()
      .then(resp => {
        if (resp.ok && Array.isArray(resp.comandas)) {
          setComandas(resp.comandas);
        } else {
          console.error(resp.error || 'No se pudo obtener comandas');
        }
      })
      .catch(err => console.error(err));
  }, []);

  const seleccionarComanda = (id) => {
    if (!id) return;
    const comanda = comandas.find(c => c._id === id);
    if (comanda) {
      setViaje(prev => ({
        ...prev,
        nroViaje: comanda.nroviaje,
        comandaId: comanda._id,
        choferId: comanda.codcho?._id || '',
        camionId: comanda.codcam?._id || '',
        chofer: comanda.codcho?.nombre || '',
        camion: comanda.codcam?.patente || ''
      }));
    }
  };

  const [estaciones, setEstaciones] = useState([]);
  const [cajas, setCajas] = useState([]);

  useEffect(() => {
    getEstaciones().then(resp => {
      if (resp.ok && Array.isArray(resp.estaciones)) {
        setEstaciones(resp.estaciones);
      }
    });
  }, []);

  useEffect(() => {
    getCajas()
      .then(resp => {
        if (resp.ok && Array.isArray(resp.cajas)) {
          setCajas(resp.cajas);
        } else if (Array.isArray(resp)) {
          setCajas(resp);
        } else {
          console.error(resp.error || resp.msg || 'No se pudo obtener cajas');
        }
      })
      .catch(err => console.error('Error al cargar cajas:', err));
  }, []);

  const [nuevoTramo, setNuevoTramo] = useState({ fecha: '', origen: '', destino: '', remito: '', kmInicial: 0, kmFinal: 0 });
  const [nuevaCarga, setNuevaCarga] = useState({ fecha: '', litros: '', monto: '', metodoPago: '', estacion: '', localidad: '', kmTablero: '' });
  const [nuevoViatico, setNuevoViatico] = useState({ descripcion: '', monto: '' });
  const [nuevoAdelanto, setNuevoAdelanto] = useState({
    descripcion: '',
    monto: '',
    caja: ''
});
  const [nuevoGasto, setNuevoGasto] = useState({ descripcion: '', monto: '' });

  const agregarTramo = () => {
    setViaje(prev => ({ ...prev, tramos: [...prev.tramos, nuevoTramo] }));
    setNuevoTramo({ fecha: '', origen: '', destino: '', remito: '', kmInicial: 0, kmFinal: 0 });
  };

  const agregarCarga = () => {
    setViaje(prev => ({ ...prev, combustible: [...prev.combustible, nuevaCarga] }));
    setNuevaCarga({ fecha: '', litros: '', monto: '', metodoPago: '', estacion: '', localidad: '', kmTablero: '' });
  };

  const agregarViatico = () => {
    setViaje(prev => ({ ...prev, viaticos: [...prev.viaticos, nuevoViatico] }));
    setNuevoViatico({ descripcion: '', monto: '' });
  };

  const agregarAdelanto = () => {
    const monto = Number(nuevoAdelanto.monto) || 0;

    if (monto > 0 && !nuevoAdelanto.caja) {
      alert("Para cargar un adelanto debés seleccionar la caja de donde sale el dinero.");
      return;
    }

    setViaje(prev => ({
      ...prev,
      adelantos: [
        ...prev.adelantos,
        {
          descripcion: nuevoAdelanto.descripcion,
          monto,
          caja: nuevoAdelanto.caja
        }
      ]
    }));

    setNuevoAdelanto({
      descripcion: '',
      monto: '',
      caja: ''
    });
  };

  const agregarGasto = () => {
    setViaje(prev => ({ ...prev, gastos: [...prev.gastos, nuevoGasto] }));
    setNuevoGasto({ descripcion: '', monto: '' });
  };

  const totalKm = viaje.tramos.reduce((sum, t) => sum + (Number(t.kmFinal) - Number(t.kmInicial)), 0);
  const totalLitros = viaje.combustible.reduce((sum, c) => sum + Number(c.litros), 0);
  const promedioConsumo = totalLitros > 0 ? (totalKm / totalLitros).toFixed(2) : 0;
  const totalCombustible = viaje.combustible.reduce((sum, c) => sum + Number(c.monto), 0);
  const totalViaticos = viaje.viaticos.reduce((sum, v) => sum + Number(v.monto), 0);
  const totalAdelantos = viaje.adelantos.reduce((sum, a) => sum + Number(a.monto), 0);
  const totalGastos = viaje.gastos.reduce((sum, g) => sum + Number(g.monto), 0);
  const liquidacionFinal = totalKm * Number(viaje.valorKM) + totalViaticos - totalAdelantos - totalGastos;

  const getId = (valor) => {
    if (!valor) return null;
    if (typeof valor === "object" && valor._id) return valor._id;
    return valor;
  };

  const handleSubmit = async () => {
    if (!viaje.nroViaje || !viaje.choferId || !viaje.camionId || !viaje.comandaId) {
      alert("Faltan datos obligatorios del viaje.");
      return;
    }

    const viajePayload = {
      nroViaje: Number(viaje.nroViaje), // aseguramos número
      comandaId: viaje.comandaId,
      choferId: viaje.choferId,
      camionId: viaje.camionId,
      tarifaPorKm: Number(viaje.valorKM),
      kmInicioTablero:
        viaje.kmInicioTablero === '' || viaje.kmInicioTablero == null
          ? null
          : Number(viaje.kmInicioTablero),

      kmFinTablero:
        viaje.kmFinTablero === '' || viaje.kmFinTablero == null
          ? null
          : Number(viaje.kmFinTablero),
      tramos: viaje.tramos.map(t => ({
        ...t,
        fecha: t.fecha ? new Date(t.fecha) : null,
        kmInicial: Number(t.kmInicial) || 0,
        kmFinal: Number(t.kmFinal) || 0
      })),
      combustible: viaje.combustible.map(c => ({
        ...c,
        fecha: c.fecha ? new Date(c.fecha) : null,
        litros: Number(c.litros) || 0,
        monto: Number(c.monto) || 0,
        kmTablero: Number(c.kmTablero) || 0
      })),
      viaticos: viaje.viaticos.map(v => ({
        descripcion: v.descripcion,
        monto: Number(v.monto) || 0
      })),
      adelantos: viaje.adelantos.map(a => ({
        _id: a._id,
        descripcion: a.descripcion,
        monto: Number(a.monto) || 0,
        caja: getId(a.caja),
        movimiento: getId(a.movimiento),
        impactaCaja: !!a.impactaCaja,

        // Datos del viaje para el movimiento generado
        // comanda: viaje.comandaId,
        // camion: viaje.camionId,
        // chofer: viaje.choferId
      })),
      gastos: viaje.gastos.map(g => ({
        descripcion: g.descripcion,
        monto: Number(g.monto) || 0
      })),
      totalKm,
      totalCombustible,
      totalViaticos,
      totalAdelantos,
      totalGastos,
      liquidacionFinal
    };

    // ✅ LOGS DE DEBUG
    console.log('📤 Payload a enviar:', viajePayload);
    console.log('🔁 Método HTTP:', viaje._id ? 'PUT (editar)' : 'POST (nuevo)');

  try {
    const res = viaje._id
      ? await putViaje(viaje._id, viajePayload)
      : await postViaje(viajePayload);

    console.log('📥 Respuesta del servidor:', res);

    if (res.ok || res._id) {
      alert("✅ Viaje guardado correctamente");

      // 🔄 Limpiar el formulario después del guardado
      setViaje({
        nroViaje: '',
        chofer: '',
        camion: '',
        valorKM: 130,
        kmInicioTablero: '',
        kmFinTablero: '',
        tramos: [],
        combustible: [],
        viaticos: [],
        adelantos: [],
        gastos: []
      });
    } else {
      if (res.error?.error?.includes('duplicate key')) {
        alert('❌ El número de viaje ya fue guardado anteriormente.');
      } else {
        alert('❌ Error: ' + (res.error?.error || res.error || 'Error al guardar el viaje'));
      }
    }
  } catch (err) {
    console.error('❌ Error inesperado en catch:', err?.response?.data || err);
    alert('❌ Error inesperado: ' + (err?.response?.data?.message || err.message));
  }


  };


  return (
    <div className="p-4 space-y-6">
      <div className="flex gap-4 flex-wrap">
        <select 
          className="border p-2" 
          style={{ width: '40rem' , fontSize: '1.5rem' }} // 12px
          onChange={e => seleccionarComanda(e.target.value)}>
          <option value="">Seleccionar viaje desde comanda</option>
          {comandas.map(c => (
            <option key={c._id} value={c._id}>{c.nroviaje} - {c.codcho?.nombre} / {c.codcam?.patente}</option>
          ))}
        </select>
         
        <div className="form-row">
          <div className="form-group mt-3 col-sm-3">
            <label className="mr-3">Nro de Viaje:</label>
            <input className="border p-2" placeholder="Nro de viaje" disabled value={viaje.nroViaje} onChange={e => setViaje({ ...viaje, nroViaje: e.target.value })} />
          </div>

          <div className="form-group mt-3 col-sm-3">
            <label className="mr-3">Chofer:</label>
            <input className="border p-2" placeholder="Chofer" disabled value={viaje.chofer} onChange={e => setViaje({ ...viaje, chofer: e.target.value })} />
           </div>

          <div className="form-group mt-3 col-sm-3">
            <label className="mr-3">Camion:</label>
            <input className="border p-2" placeholder="Camión" disabled value={viaje.camion} onChange={e => setViaje({ ...viaje, camion: e.target.value })} />
          </div>

          <div className="form-group mt-3 col-sm-3">
            <label className="mr-3">Costo Km:</label>
            <input className="border p-2" style={{ color: 'red'}} placeholder="Valor por KM" value={viaje.valorKM} onChange={e => setViaje({ ...viaje, valorKM: Number(e.target.value) })} />
          </div>

        </div>
        {/* <input className="border p-2" placeholder="Nro de viaje" value={viaje.nroViaje} onChange={e => setViaje({ ...viaje, nroViaje: e.target.value })} />
        <input className="border p-2" placeholder="Chofer" value={viaje.chofer} onChange={e => setViaje({ ...viaje, chofer: e.target.value })} />
        <input className="border p-2" placeholder="Camión" value={viaje.camion} onChange={e => setViaje({ ...viaje, camion: e.target.value })} />
        <input className="border p-2" placeholder="Valor por KM" value={viaje.valorKM} onChange={e => setViaje({ ...viaje, valorKM: Number(e.target.value) })} /> */}
      </div>

      <div className="form-row">
        <div className="form-group mt-3 col-sm-3">
          <label htmlFor="kmInicioTablero" className="mr-3">
            KM Inicio Tablero:
          </label>
          <input
            id="kmInicioTablero"
            className="border p-2"
            type="number"
            min="0"
            step="1"
            style={{ color: 'red', width: '100%' }}
            placeholder="Lectura al iniciar el viaje"
            value={viaje.kmInicioTablero ?? ''}
            onChange={e =>
              setViaje(prev => ({
                ...prev,
                kmInicioTablero: e.target.value
              }))
            }
          />
        </div>

        <div className="form-group mt-3 col-sm-3">
          <label htmlFor="kmFinTablero" className="mr-3">
            KM Fin Tablero:
          </label>
          <input
            id="kmFinTablero"
            className="border p-2"
            type="number"
            min="0"
            step="1"
            style={{ color: 'red', width: '100%' }}
            placeholder="Lectura al finalizar el viaje"
            value={viaje.kmFinTablero ?? ''}
            onChange={e =>
              setViaje(prev => ({
                ...prev,
                kmFinTablero: e.target.value
              }))
            }
          />
        </div>
      </div>

      <div className="mt-4">
        <h2 className="font-bold" style={{ color: 'blue' , fontSize: '1.5rem' }}>Tramos</h2>
          {viaje.tramos.map((t, i) => (
            <div key={i} className="flex gap-2 mb-1">
              <span>{viaje.nroViaje}.{i + 1}</span>
              <TextoAzul> Fecha: {t.fecha} | Origen: {t.origen} → Destino: {t.destino} | Remito: {t.remito}</TextoAzul>
              {/* <TextoAzul> Fecha: {t.fecha} | Origen: {t.origen} → Destino: {t.destino} | Remito: {t.remito} | KM: {t.kmInicial} - {t.kmFinal}</TextoAzul> */}
            </div>
          ))}

        <div className="flex gap-2 flex-wrap mt-2">
          <input className="border p-1" type="date" style={{  width: '16rem' , fontSize: '1.5rem' }} placeholder="Fecha" value={nuevoTramo.fecha} onChange={e => setNuevoTramo({ ...nuevoTramo, fecha: e.target.value })} />
          <input className="border p-1" style={{ width: '40rem' , fontSize: '1.5rem' }} placeholder="Origen" value={nuevoTramo.origen} onChange={e => setNuevoTramo({ ...nuevoTramo, origen: e.target.value })} />
          <input className="border p-1" style={{ width: '40rem' , fontSize: '1.5rem' }} placeholder="Destino" value={nuevoTramo.destino} onChange={e => setNuevoTramo({ ...nuevoTramo, destino: e.target.value })} />
          <input className="border p-1" style={{ fontSize: '1.5rem' }} placeholder="Remito" value={nuevoTramo.remito} onChange={e => setNuevoTramo({ ...nuevoTramo, remito: e.target.value })} />
          {/* <input className="border p-1" style={{ fontSize: '1.5rem' }} placeholder="KM Inicial" value={nuevoTramo.kmInicial} onChange={e => setNuevoTramo({ ...nuevoTramo, kmInicial: e.target.value })} />
          <input className="border p-1" style={{ fontSize: '1.5rem' }} placeholder="KM Final" value={nuevoTramo.kmFinal} onChange={e => setNuevoTramo({ ...nuevoTramo, kmFinal: e.target.value })} /> */}
          <BotonForm onClick={agregarTramo}>+ Tramo</BotonForm>

        </div>
      </div>

      {/* Combustible */}
      <div className="mt-4">
        <h2 className="font-bold" style={{ color: 'blue' , fontSize: '1.5rem' }}>Cargas de Combustible</h2>
        {viaje.combustible.map((c, i) => (
          <div key={i} className="flex gap-2 mb-1">
            {/* <TextoAzul>Fecha: {c.fecha} | {c.litros} Litros | ${c.monto} | {c.metodoPago} - Localidad: {c.localidad} | KM: {c.kmTablero}</TextoAzul> */}
            <TextoAzul>Fecha: {c.fecha} | {c.litros} Litros | ${c.monto} | {c.metodoPago} - Estación: {typeof c.estacion === 'object'
  ? c.estacion.estacion
  : (estaciones.find(est => est._id === c.estacion)?.estacion || c.estacion)}
, Localidad: {c.localidad} | KM Tablero: {c.kmTablero}</TextoAzul>
          </div>
        ))}
        <div className="flex gap-2 flex-wrap mt-2">
          <input className="border p-1" type="date" style={{ width: '16rem' , fontSize: '1.5rem' }} placeholder="Fecha" value={nuevaCarga.fecha} onChange={e => setNuevaCarga({ ...nuevaCarga, fecha: e.target.value })} />
          <input className="border p-1" style={{ width: '10rem' , fontSize: '1.5rem'}} placeholder="Litros" value={nuevaCarga.litros} onChange={e => setNuevaCarga({ ...nuevaCarga, litros: e.target.value })} />
          <input className="border p-1" style={{ width: '12rem' , fontSize: '1.5rem' }} placeholder="Monto" value={nuevaCarga.monto} onChange={e => setNuevaCarga({ ...nuevaCarga, monto: e.target.value })} />
          <input className="border p-1" style={{ width: '12rem', fontSize: '1.5rem' }} placeholder="Km de Tablero" value={nuevaCarga.kmTablero} onChange={e => setNuevaCarga({ ...nuevaCarga, kmTablero: e.target.value })} />
          <select className="border p-1" style={{ width: '16rem' , fontSize: '1.5rem' }}value={nuevaCarga.metodoPago} onChange={e => setNuevaCarga({ ...nuevaCarga, metodoPago: e.target.value })}>
            <option value="">Metodo de Pago</option>
            <option value="Efectivo">Efectivo</option>
            <option value="YPF Ruta">YPF Ruta</option>
            <option value="Transferencia">Transferencia</option>
            <option value="Cta. Cte.">Cta. Cte.</option>
          </select>
          {/* <input className="border p-1" style={{ width: '26rem' , fontSize: '1.5rem' }} placeholder="Localidad" value={nuevaCarga.localidad} onChange={e => setNuevaCarga({ ...nuevaCarga, localidad: e.target.value })} /> */}
          {/* <input className="border p-1" style={{ width: '20rem' , fontSize: '1.5rem' }} placeholder="Estación" value={nuevaCarga.estacion} onChange={e => setNuevaCarga({ ...nuevaCarga, estacion: e.target.value })} /> */}
          <select
            className="border p-1"
            style={{ width: '20rem', fontSize: '1.5rem' }}
            value={nuevaCarga.estacion}
            onChange={e => setNuevaCarga({ ...nuevaCarga, estacion: e.target.value })}
          >
            <option value="">Seleccionar Estación</option>
            {estaciones.map(est => (
              <option key={est._id} value={est._id}>
                {est.estacion}
              </option>
            ))}
          </select>
          <input className="border p-1" style={{ width: '26rem' , fontSize: '1.5rem' }} placeholder="Localidad" value={nuevaCarga.localidad} onChange={e => setNuevaCarga({ ...nuevaCarga, localidad: e.target.value })} />
          <BotonForm onClick={agregarCarga}>+ Carga</BotonForm>
        </div>
      </div>

      {/* Viáticos */}
      <div className="mt-4">
        <h2 className="font-bold" style={{ color: 'blue' , fontSize: '1.5rem' }}>Viáticos</h2>
        {viaje.viaticos.map((v, i) => (
          <div key={i} className="flex gap-2 mb-1">
            <TextoAzul>Descripción: {v.descripcion} - Monto: ${v.monto}</TextoAzul>
          </div>
        ))}
        <div className="flex gap-2 flex-wrap mt-2">
          <input className="border p-1" style={{ width: '60rem' , fontSize: '1.5rem' }} placeholder="Descripción" value={nuevoViatico.descripcion} onChange={e => setNuevoViatico({ ...nuevoViatico, descripcion: e.target.value })} />
          <input className="border p-1" style={{ fontSize: '1.5rem'}} placeholder="Monto" value={nuevoViatico.monto} onChange={e => setNuevoViatico({ ...nuevoViatico, monto: e.target.value })} />
          <BotonForm onClick={agregarViatico}>+ Viático</BotonForm>
        </div>
      </div>

      {/* Adelantos */}
      <div className="mt-4">
        <h2 className="font-bold" style={{ color: 'blue', fontSize: '1.5rem' }}>Adelantos</h2>

        {viaje.adelantos.map((a, i) => {
          const cajaId = getId(a.caja);
          const cajaNombre =
            typeof a.caja === "object" && a.caja?.descripcion
              ? a.caja.descripcion
              : cajas.find(c => c._id === cajaId)?.descripcion || "Sin caja";

          return (
            <div key={i} className="flex gap-2 mb-1">
              <TextoAzul>
                Descripción: {a.descripcion} - Monto: ${a.monto} - Caja: {cajaNombre}
              </TextoAzul>
            </div>
          );
        })}

        <div className="flex gap-2 flex-wrap mt-2">
          <input
            className="border p-1"
            style={{ width: '40rem', fontSize: '1.5rem'}}
            placeholder="Descripción"
            value={nuevoAdelanto.descripcion}
            onChange={e => setNuevoAdelanto({ ...nuevoAdelanto, descripcion: e.target.value })}
          />

          <input
            className="border p-1"
            style={{ width: '14rem', fontSize: '1.5rem'}}
            placeholder="Monto"
            value={nuevoAdelanto.monto}
            onChange={e => setNuevoAdelanto({ ...nuevoAdelanto, monto: e.target.value })}
          />

          <select
            className="border p-1"
            style={{ width: '26rem', fontSize: '1.5rem' }}
            value={nuevoAdelanto.caja}
            onChange={e => setNuevoAdelanto({ ...nuevoAdelanto, caja: e.target.value })}
          >
            <option value="">Seleccionar Caja</option>
            {cajas.map(caja => (
              <option key={caja._id} value={caja._id}>
                {caja.descripcion} - Saldo: ${formatoDinero(caja.saldoActual)}
              </option>
            ))}
          </select>

          <BotonForm onClick={agregarAdelanto}>+ Adelanto</BotonForm>
        </div>
      </div>

      {/* Gastos */}
      <div className="mt-4">
        <h2 className="font-bold" style={{ color: 'blue', fontSize: '1.5rem' }}>Gastos</h2>
        {viaje.gastos.map((g, i) => (
          <div key={i} className="flex gap-2 mb-1">
            <TextoAzul>Descripción: {g.descripcion} - Monto: ${g.monto}</TextoAzul>
          </div>
        ))}
        <div className="flex gap-2 flex-wrap mt-2">
          <input className="border p-1" style={{ width: '60rem', fontSize: '1.5rem'}} placeholder="Descripción" value={nuevoGasto.descripcion} onChange={e => setNuevoGasto({ ...nuevoGasto, descripcion: e.target.value })} />
          <input className="border p-1" style={{ fontSize: '1.5rem'}} placeholder="Monto" value={nuevoGasto.monto} onChange={e => setNuevoGasto({ ...nuevoGasto, monto: e.target.value })} />
          <BotonForm onClick={agregarGasto}>+ Gasto</BotonForm>
        </div>
      </div>

      {/* Resumen y botón guardar */}
      <div className="border p-4 mt-4">
        <h2 className="font-bold mb-2">Resumen de Liquidación</h2>
        <p>Total KM recorridos: {totalKm}</p>
        <p>Total Combustible: ${totalCombustible}</p>
        <p>Total litros cargados: {totalLitros}</p>
        <p>Promedio de consumo: {promedioConsumo} km/l</p>
        <p>Total Viáticos: ${totalViaticos}</p>
        <p>Total Adelantos: ${totalAdelantos}</p>
        <p>Total Gastos: ${totalGastos}</p>
       <p className="font-bold text-lg mt-2">Total a Cobrar: ${liquidacionFinal}</p>
      </div>

      <button className="btn btn-dark mt-5 mb-3" onClick={handleSubmit}>Guardar Viaje</button>
    </div>
  );
}

